function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "twitter",
  transform: "translate(-398 -84.829)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M108.2,48.985l.484,7.965-8.051-.975c-29.3-3.739-54.9-16.417-76.638-37.711L13.363,7.7l-2.737,7.8c-5.8,17.392-2.093,35.76,9.982,48.113,6.44,6.827,4.991,7.8-6.118,3.738-3.864-1.3-7.245-2.276-7.567-1.788C5.8,66.7,9.66,81.494,12.719,87.345c4.186,8.127,12.719,16.092,22.058,20.806l7.889,3.739-9.338.163c-9.016,0-9.338.163-8.372,3.576,3.22,10.565,15.94,21.781,30.108,26.657l9.982,3.414-8.694,5.2A90.649,90.649,0,0,1,13.2,162.929c-7.245.163-13.2.813-13.2,1.3,0,1.626,19.643,10.729,31.074,14.3,34.294,10.565,75.028,6.014,105.619-12.029,21.736-12.841,43.472-38.361,53.615-63.068,5.474-13.166,10.948-37.223,10.948-48.764,0-7.477.484-8.452,9.5-17.392,5.313-5.2,10.3-10.891,11.27-12.516,1.61-3.088,1.449-3.088-6.762-.325-13.685,4.876-15.618,4.226-8.855-3.088,4.991-5.2,10.948-14.629,10.948-17.392,0-.488-2.415.325-5.152,1.788a89.813,89.813,0,0,1-14.168,5.527l-8.694,2.763-7.89-5.364c-4.347-2.926-10.465-6.177-13.685-7.152-8.212-2.276-20.77-1.951-28.176.65C119.466,9.487,106.747,28.342,108.2,48.985Z",
  transform: "translate(398 84.829)",
  fill: "#fff",
  fillRule: "evenodd"
}));

function SvgTwitterLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 222.828 184.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLight);
export default __webpack_public_path__ + "static/media/twitterLight.7d5c1ab4.svg";
export { ForwardRef as ReactComponent };